import { isElementDataNode, isHidden, isTextNode } from './nodes/helpers';
import { ElementKind } from '@domain/elements';
export function visitOneNode(node, visitor) {
    if (isElementDataNode(node) && isHidden(node)) {
        return;
    }
    switch (node.kind) {
        case "creative" /* CreativeKind.Creative */:
            visitor.visitCreative_m(node);
            break;
        case ElementKind.Rectangle:
            visitor.visitRectangle_m(node);
            break;
        case ElementKind.Ellipse:
            visitor.visitEllipse_m(node);
            break;
        case ElementKind.Image:
            visitor.visitImage_m(node);
            break;
        case ElementKind.Text:
            visitor.visitText_m(node);
            break;
        case ElementKind.Button:
            visitor.visitButton_m(node);
            break;
        case ElementKind.Widget:
            visitor.visitWidget_m(node);
            break;
        case ElementKind.Video:
            visitor.visitVideo_m(node);
            break;
    }
}
export function visitAllNodes(node, visitor, visitOnlyTextLikeNodes = false) {
    switch (node.kind) {
        case "creative" /* CreativeKind.Creative */:
            visitor.visitCreative_m(node);
            visitAllChildren(node.nodes, visitor, visitOnlyTextLikeNodes);
            break;
        case ElementKind.Group:
            visitAllChildren(node.nodes, visitor, visitOnlyTextLikeNodes);
            break;
        default:
            if (!visitOnlyTextLikeNodes || isTextNode(node)) {
                visitOneNode(node, visitor);
            }
    }
}
export function visitAllChildren(children, visitor, visitOnlyTextLikeNodes = false) {
    for (const child of children) {
        if (!isHidden(child)) {
            visitAllNodes(child, visitor, visitOnlyTextLikeNodes);
        }
    }
}
